import { useEffect } from 'react';

import { useLabelingBoxStore, useToolMenuStore } from '@/store';

import {
  useAddBox,
  useBoxFocusShortcut,
  useClipboardShortcut,
  useRemoveBoxListShortcut,
  useToggleBoxArrowHelper,
  useTrackIDShortcut,
} from './hook';

const ToolPcdCanvasMainViewShortcut = () => {
  const toolMap = useToolMenuStore(state => state.toolMap);
  const pcdIndexBoxListMap = useLabelingBoxStore(
    state => state.pcdIndexBoxListMap,
  );

  useAddBox();
  useRemoveBoxListShortcut();
  useClipboardShortcut();
  useToggleBoxArrowHelper();
  useBoxFocusShortcut();
  useTrackIDShortcut();

  useEffect(() => {
    const selectAllTool = useToolMenuStore.getState().findByName('selectAll');
    const deselectAllToolMenu = useToolMenuStore
      .getState()
      .findByName('deselectAllToolMenu');

    if (selectAllTool?.isSelected) {
      useLabelingBoxStore.getState().selectBoxList(
        useLabelingBoxStore
          .getState()
          .getCurrentBoxList()
          .map(b => b.id),
      );
    }

    if (deselectAllToolMenu?.isSelected) {
      useToolMenuStore.getState().clear();
    }
  }, [toolMap, pcdIndexBoxListMap]);

  return <></>;
};

export default ToolPcdCanvasMainViewShortcut;
